import { ITimeEntry, ITimeEntryDay, TimeEntryDayBlock } from '../../queries/TimeEntry';

export interface ITimesheetRow {
	day: string;
	entry?: ITimeEntry;
	block?: TimeEntryDayBlock;
	isOverdue: boolean;
}

export function buildTimesheetRows({
	entries,
	overdueDays,
	today,
}: {
	entries: ITimeEntry[];
	overdueDays: ITimeEntryDay[];
	today?: ITimeEntryDay;
}): ITimesheetRow[] {
	const rows = new Map<string, ITimesheetRow>();
	for (const entry of entries) {
		rows.set(entry.day, { day: entry.day, entry, isOverdue: false });
	}
	for (const overdue of overdueDays) {
		const existing = rows.get(overdue.day);
		rows.set(overdue.day, {
			block: overdue.block,
			day: overdue.day,
			entry: overdue.entry ?? existing?.entry,
			isOverdue: true,
		});
	}
	if (today?.isRequired && !rows.has(today.day)) {
		rows.set(today.day, { block: today.block, day: today.day, entry: today.entry, isOverdue: false });
	}
	return [...rows.values()].sort((a, b) => b.day.localeCompare(a.day));
}

export function describeTimesheetRow(row: ITimesheetRow, formatDateTime: (iso?: string) => string) {
	const { entry } = row;
	switch (entry?.status) {
		case 'Rejected':
			return entry.reviewComment ? `“${entry.reviewComment}”` : 'Sent back for changes';
		case 'Submitted':
			return `Submitted ${formatDateTime(entry.submittedAt)}`;
		case 'Approved':
			return `Approved ${formatDateTime(entry.reviewedAt)}`;
		case 'Draft':
			return entry.hours === undefined ? 'No hours entered' : 'Saved, not submitted';
		default:
			return 'No hours entered';
	}
}
